module.exports = __webpack_public_path__ + "static/media/Maria_Pereira.0877a8a7.jpg";